/*
 * @Description: 
 * @Author: 长老
 * @Date: 2019-04-19 14:37:18
 * @LastEditTime : 2020-01-14 10:05:15
 * @LastEditors  : 陆伟
 */
/* eslint-disable */
// if (process.env.NODE_ENV === 'production') {
//   __webpack_public_path__ = window.PUBLIC_PATH + '/yjcommodity/'
// }
import { YjErrorReport } from '@yunji/report'
import '@/assets/config/globalConfig'
import Vue from 'vue'
import '@/assets/fonts/iconfont.css'
import App from './App.vue'
import router from './router'
import YunJi from '@/assets/js/YunJi'
import '@/assets/js/filter'
import './filter'
import '@yunji/h5/lib/index.css';
import store from './store'

//  本地环境及测试环境增加vconsole
const domain = location.hostname.search(/(local.|v.|t.|txst.|lb-tx.|ys-txst.|special-al-dev.)/)
if (domain === 0) {
  const script = document.createElement('script')
  const style = document.createElement('style')
  style.appendChild(document.createTextNode('.vc-table{ line-height: 1.3; }'))
  script.src = '//static.yunjiglobal.com/qnUpload/frontend/js/vconsole.dev.js'
  document.body.appendChild(script)
  document.body.appendChild(style)
}


YunJi.initRem()// 初始化字体rem

// 每次进入路由设置标题
router.afterEach((to, from) => {
  to.meta.title && (document.title = to.meta.title)
})

/**
 * 输出JENKINS信息
 */
const returnPackage = () => {
  if (typeof window.JENKINS !== 'undefined' && window.JENKINS.packageName) {
    return {
      packageName: window.JENKINS.packageName,
      packageVersion: window.JENKINS.packageVersion
    }
  }
  return {}
}

// eslint-disable-next-line no-unused-vars
const yjerror = new YjErrorReport(Vue, {
  projectName: 'commodity',
  environment: domain === 0 ? 'test' : 'release',
  packageName: returnPackage().packageName,
  packageVersion: returnPackage().packageVersion
})

new Vue({
  el: '#app',
  router,
  store,
  render: h => h(App)
})
